<template>
  <div :class="pointsClass()" :style="cssVars" class="row center colorPointsBg position-relative mb-5">
      <div id="phylactere"
           class="bg-light position-absolute">
        <div class="bg-color text-light bold">
          <h1 class="font-weight-bold" v-html="message.titre"></h1>
          <p v-html="message.sousTitre"></p>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'ColorPointsHeader',
  props: {
    message: Object,
    color: String
  },
  computed: {
    cssVars () {
      return {
        '--color': this.color.replace('a', '').replace(', 0.5', '')
      }
    }
  },
  methods: {
    pointsClass () {
      switch (this.color) {
        case 'rgba(227, 13, 104, 0.5)' :
          return 'pink'
        case 'rgba(190, 206, 35, 0.5)' :
          return 'green'
      }
    }
  }
}
</script>

<style lang="scss">
  .colorPointsBg {
    height: 12rem !important ;
    max-width: 82rem;
    background-position: center top !important;
    background-repeat: no-repeat !important;
    display: flex;
    justify-content: end;
    align-items: flex-end;
    #phylactere {
      width: 40rem ;
      height: 8rem;
      border-radius: 40px 40px 0px 40px !important;
      .bg-color {
        background-color: var(--color) !important;
        border-radius: 40px 40px 0px 40px !important;
        padding: 1.5rem 2.3rem 1.2rem 2.3rem !important ;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: start;
        flex-direction: column;
      }
      h1 {
        font-size: 1.5rem !important ;
      }
      max-width: 100% !important ;
      // bottom: 0rem !important ;
      // right: 0rem !important ;
    }
  }
  .colorPointsBg.green {
    background: url('../assets/images/effet-points-verts-CGcourtage.svg');
  }
  .colorPointsBg.pink {
    background: url('../assets/images/effet-points-roses-tolusimmo.svg');
  }
  @media (max-width: 767px) {
    .colorPointsBg {
      #phylactere {
        h1 {
          font-size: 1.5rem !important ;
        }
      }
    }
  }
</style>
